/* @ngInject */
const fieldsResource = (
  accountFields,
  dispatchFields,
  ownerFields,
  contactFields,
  railwayFields,
  areaFields,
  trainFields,
  wagonFields,
  movementFields,
  saleFields,
  axletreeFields,
  sterileFields,
  pieceFields,
  settingFields,
  labels,
  icons,
  types
) => {
  const self = {}

  self.account = accountFields
  self.dispatch = dispatchFields
  self.owner = ownerFields
  self.contact = contactFields
  self.railway = railwayFields
  self.area = areaFields
  self.train = trainFields
  self.wagon = wagonFields
  self.movement = movementFields
  self.sale = saleFields
  self.axletree = axletreeFields
  self.sterile = sterileFields
  self.piece = pieceFields
  self.setting = settingFields

  self.global = {
    'sort': {
      label: labels.sort,
      icon: icons.sort,
      input: {
        type: types.text(),
      },
      output: {

      },
    },
    'title': {
      label: labels.title,
      icon: icons.title,
      input: {
        type: types.text(),
      },
      output: {

      },
    },
    'fileName': {
      label: labels.fileName,
      icon: icons.excel,
      input: {
        type: types.text(),
      },
      output: {},
    },
  }

  return self
}
export default fieldsResource



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/resources/fields.resource.js